export const alchemyRecipes = {
  healing: [
    {
      potion: 'Healing',
      water: 2,
      oil: '',
      vinegar: '',
      blood: '',
      clay: 1,
      bark: '',
      root: '',
      limestone: '',
      bone: '',
      mushroom: '',
      iron: '',
      acorn: '',
    },
    {
      potion: 'Stamina',
      water: 2,
      oil: '',
      vinegar: '',
      blood: '',
      clay: '',
      bark: 1,
      root: '',
      limestone: '',
      bone: '',
      mushroom: '',
      iron: '',
      acorn: '',
    },
    {
      potion: 'Mana',
      water: 2,
      oil: '',
      vinegar: '',
      blood: '',
      clay: '',
      bark: '',
      root: 1,
      limestone: '',
      bone: '',
      mushroom: '',
      iron: '',
      acorn: '',
    },
    {
      potion: 'Rejuvenation',
      water: '',
      oil: 1,
      vinegar: '',
      blood: '',
      clay: '',
      bark: '',
      root: '',
      limestone: 1,
      bone: '',
      mushroom: '',
      iron: '',
      acorn: '',
    },
    {
      potion: 'Body',
      water: '',
      oil: '',
      vinegar: 1,
      blood: '',
      clay: '',
      bark: '',
      root: '',
      limestone: '',
      bone: '',
      mushroom: 1,
      iron: '',
      acorn: 1,
    },
  ],
  support: [
    {
      potion: 'Antivenin',
      water: '',
      oil: '',
      vinegar: '',
      blood: '',
      clay: 1,
      bark: '',
      root: 1,
      limestone: '',
      bone: '',
      mushroom: '',
      iron: '',
      acorn: '',
    },
    {
      potion: 'Combat',
      water: '',
      oil: '',
      vinegar: '',
      blood: 1,
      clay: '',
      bark: '',
      root: '',
      limestone: 1,
      bone: '',
      mushroom: '',
      iron: '',
      acorn: '',
    },
    {
      potion: 'Experience',
      water: '',
      oil: '',
      vinegar: '',
      blood: 1,
      clay: '',
      bark: '',
      root: '',
      limestone: '',
      bone: 1,
      mushroom: '',
      iron: '',
      acorn: '',
    },
    {
      potion: 'Ironskin',
      water: '',
      oil: '',
      vinegar: '',
      blood: '',
      clay: '',
      bark: '',
      root: '',
      limestone: '',
      bone: 1,
      mushroom: '',
      iron: 1,
      acorn: '',
    },
  ],
  damage: [
    {
      potion: 'Freeze',
      water: '',
      oil: '',
      vinegar: 1,
      blood: '',
      clay: '',
      bark: '',
      root: '',
      limestone: '',
      bone: '',
      mushroom: 1,
      iron: '',
      acorn: '',
    },
    {
      potion: 'Lightning',
      water: '',
      oil: '',
      vinegar: 1,
      blood: '',
      clay: '',
      bark: '',
      root: '',
      limestone: '',
      bone: '',
      mushroom: '',
      iron: 1,
      acorn: '',
    },
    {
      potion: 'Burn',
      water: '',
      oil: '',
      vinegar: 1,
      blood: '',
      clay: '',
      bark: '',
      root: '',
      limestone: '',
      bone: '',
      mushroom: '',
      iron: '',
      acorn: 1,
    },
  ],
};

export const ingredients = [
  'Water',
  'Oil',
  'Vinegar',
  'Blood',
  'Clay',
  'Bark',
  'Root',
  'Limestone',
  'Bone',
  'Mushroom',
  'Iron',
  'Acorn',
];
